import { MonthSelection } from '@e2m-customer-portal/ui';
import { addYears, eachMonthOfInterval, endOfYear, getMonth, getYear, startOfYear, subYears, Interval } from 'date-fns';

export function useMonthSelection(lastYear: MonthSelection, thisYear: MonthSelection): Interval[] {
  const currentYear = getYear(new Date());
  const result: Interval[] = [];
  let accumulator: Date[] = [];

  for (const date of eachMonthOfInterval({ start: startOfYear(subYears(new Date(), 1)), end: endOfYear(new Date()) })) {
    const selection = getYear(date) < currentYear ? lastYear : thisYear;
    if (selection[getMonth(date)]) {
      accumulator.push(date);
    } else if (accumulator.length > 0) {
      result.push({
        start: accumulator[0],
        end: date,
      });
      accumulator = [];
    }
  }

  if (accumulator.length > 0) {
    result.push({
      start: accumulator[0],
      end: startOfYear(addYears(new Date(), 1)),
    });
  }

  return result;
}
